module.exports = __webpack_public_path__ + "static/media/Collection.ad7f543e.svg";